<template>
  <div>
    <!-- rewards section -->
    <section class="ib-section ib-rewards-bg ib-default-flex" v-if="login && recentSearchProducts.length > 0">
      <div class="container">
        <div class="row">
          <div class="col-md-6 offset-md-3 text-center">
            <h2 class="ib-section-title wow animate__animated animate__fadeInRight pt-1 pt-sm-2">
              <span>R</span>ecently Viewed Products
            </h2>
            <p class="ib-heading-desc wow animate__animated animate__fadeInLeft">Products I have viewed!</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div id="recentCarousel" class="container pt-3 pb-3 py-md-5">
              <carousel :scrollPerPage="true" :perPageCustom="[[375, 1], [768, 2], [1200, 3]]" :navigation-enabled="true" navigationNextLabel="<i class='fa fa-arrow-right'></i>"
                  navigationPrevLabel="<i class='fa fa-arrow-left'></i>" :paginationEnabled="false" :autoplay="true" :loop="true">
                <slide v-for="(product, index) in recentSearchProducts" :key="'filteredproducts' + index">
                  <div class="col text-center">
                    <div class="text-center ib-rewards-box wow animate__animated animate__fadeInUp">
                      <div class="reward-box-thead">
                        <div class="position-relative">
                          <div class="img-box">
                            <img alt="icon" class="first-img" :src="product.plan_logo" v-if="product.plan_logo != ''" />
                            <img alt="icon" class="first-img" :src="product.product_logo" v-if="product.plan_logo == ''" />
                          </div>
                          <div class="img-box2">
                            <img alt="icon" class="second-img" :src="product.company_logo" />
                          </div>
                        </div>
                        <div>
                          <h3 class="reward-box-title">{{ product.subclass_name }}</h3>
                          <h4 class="reward-box-heading" v-if="product.plan_name == ''">{{product.product_name}}</h4>
                          <h4 class="reward-box-heading" v-if="product.plan_name != ''">{{product.plan_name}}</h4>
                        </div>
                      </div>
                      <div class="d-flex text-left mt-2">
                        <a class="ib-btn-primary" @click="buyProduct(product)" style="padding: 9px 25px; !important;">Buy Now</a>
                      </div>
                    </div>
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="ib-section in-recent-bg ib-default-flex" v-else>
      <div class="container">
        <div class="row">
          <div class="col-md-6 offset-md-3 text-center">
            <h2 class="ib-section-title wow animate__animated animate__fadeInRight pt-1 pt-sm-2">
              <span>R</span>ecent Searches
            </h2>
            <p class="ib-heading-desc wow animate__animated animate__fadeInLeft">Products I have viewed!</p>
            <div class="pt-lg-5 mt-lg-5">
               <img class="in-basket-img img-fluid" :src="require('@/assets/images/empty-basket.svg')" alt="icon">
              <div class="ib-section-title">
                Search Basket is Empty!
              </div>
              <div class="ib-heading-desc" v-if="!login">
                Please <span class="in-sign ib-cursor-pointer" @click="openSignInModal()"> SignIn </span><span class="in-or">OR</span><span class="in-up ib-cursor-pointer" @click="openSignUpModal()"> SignUp</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel';

  export default {
    name: "RecentHistory",
    data() {
      return {
        login: false,
        recentSearchProducts: {}
      };
    },
    components: {
      Carousel,
      Slide
    },
    created() {
      const self = this;

      if (self.$store.getters.isAuthenticated) {
        self.login = true;
        let user = self.$store.getters.getUser;
        if(user.otp_verified && user.email_verified_at != null) {
          self.getWishlistData();
        }
      }
    },
    methods: {
      async getWishlistData() {
        const self = this;

        self.showLoader = true;
        await axios.get('recent_search').then(function (resp) {
          self.showLoader = false;
          if(resp.data.code == 200) {
            self.recentSearchProducts = resp.data.data;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        })
      },
      buyProduct(product) {
        const self = this;
        self.$router.push({ name: 'Acquisition', params: { classId: product.mainclass_id }, query : { redirectFor :'recentSearch', productId: product.id} });
        // self.$router.push({ name: 'PlanAcquisition', params: { planId: product.plan_id, redirectFrom: 'recent_search' } });
      },
      openSignInModal() {
        const self = this;
        self.$root.$emit('openSignInModal');
      },
      openSignUpModal() {
        const self = this;
        self.$root.$emit('openSignUpModal');
      }
    }
  };
</script>

<style scoped>
  @media (max-width:550px) {
    .in-basket-img {
      width: 55% !important;
    }
    .in-recent-bg {
      background:   url(~@/assets/images/bg/left-layer.svg), url(~@/assets/images/bg/right-layer.svg)#F8F9F9 !important;
      background-repeat: no-repeat !important;
      background-size: 11% 100%, 11% 100% !important;
      background-position: left center, right center !important;
      background-clip: padding-box !important;
    }
    .ib-rewards-bg {
      min-height: auto !important;
      padding: 10px 0px !important;
    }
    /* .ib-rewards-box {
      max-width: 270px !important;
      margin: 0 auto;
    } */
    .VueCarousel-navigation-button{
      position: absolute !important;
      top: 30% !important;
    }
    .ib-rewards-box{
      max-width: 240px !important;
      margin: 0 auto;
      padding: 20px 15px 10px;
    }
    .reward-box-title {
      font-size: 11px !important;
    }
    .reward-box-heading {
      font-size: 13px !important;
    }
    .ib-btn-primary {
    font-size: 11px !important;
    }

  }
  .carousel-item .col,
  .carousel-item .col-sm,
  .carousel-item .col-md {
    margin: 8px;
    height: 210px;
    background-size: cover;
    background-position: center center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/RecentHistory.vue